import React from 'react';
import PropTypes from 'prop-types';
import PricingRulesProvider from '../PricingRulesProvider';
import PricingContext from './PricingContext';

function PricingProvider(_ref) {
  var children = _ref.children,
      clientCode = _ref.clientCode,
      currency = _ref.currency,
      decimalPrecision = _ref.decimalPrecision,
      initialRules = _ref.initialRules,
      initialRulesCompiled = _ref.initialRulesCompiled,
      noTaxPrices = _ref.noTaxPrices,
      priceGroup = _ref.priceGroup,
      productFinderHook = _ref.productFinderHook,
      region = _ref.region,
      rulesValidTreshold = _ref.rulesValidTreshold,
      staticBuild = _ref.staticBuild,
      strategies = _ref.strategies;
  return /*#__PURE__*/React.createElement(PricingContext.Provider, {
    value: {
      clientCode: clientCode,
      noTaxPrices: noTaxPrices
    }
  }, /*#__PURE__*/React.createElement(PricingRulesProvider, {
    currency: currency,
    decimalPrecision: decimalPrecision,
    initialRules: initialRules,
    initialRulesCompiled: initialRulesCompiled,
    noTaxPrices: noTaxPrices,
    priceGroup: priceGroup,
    productFinderHook: productFinderHook,
    region: region,
    rulesValidTreshold: rulesValidTreshold,
    staticBuild: staticBuild,
    strategies: strategies
  }, children));
}

process.env.NODE_ENV !== "production" ? PricingProvider.propTypes = {
  children: PropTypes.node,
  clientCode: PropTypes.string,
  currency: PropTypes.string.isRequired,
  decimalPrecision: PropTypes.number,
  initialRules: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.bool,
    map: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    noFootprint: PropTypes.bool,
    ruleCode: PropTypes.string.isRequired,
    ruleName: PropTypes.string.isRequired,
    ruleThread: PropTypes.string,
    ruleType: PropTypes.oneOf(['subject', 'cart']).isRequired,
    superGroup: PropTypes.number.isRequired,
    targets: PropTypes.arrayOf(PropTypes.shape({
      constraints: PropTypes.array,
      triggers: PropTypes.array
    })),
    validFrom: PropTypes.instanceOf(Date),
    validTo: PropTypes.instanceOf(Date),
    valueAdded: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
  })),
  initialRulesCompiled: PropTypes.arrayOf(PropTypes.any),
  noTaxPrices: PropTypes.bool.isRequired,
  priceGroup: PropTypes.string,
  productFinderHook: PropTypes.func,
  region: PropTypes.string,
  rulesValidTreshold: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  serviceNames: PropTypes.shape({}),
  staticBuild: PropTypes.bool,
  strategies: PropTypes.shape({
    constraint: PropTypes.object,
    forceThreadFootprint: PropTypes.object,
    innerCondition: PropTypes.object,
    map: PropTypes.object,
    rule: PropTypes.object,
    trigger: PropTypes.object,
    valueAdded: PropTypes.object
  })
} : void 0;
PricingProvider.defaultProps = {
  children: null,
  clientCode: 'api',
  decimalPrecision: undefined,
  initialRules: undefined,
  initialRulesCompiled: undefined,
  priceGroup: undefined,
  productFinderHook: undefined,
  region: undefined,
  rulesValidTreshold: undefined,
  serviceNames: undefined,
  staticBuild: undefined,
  strategies: undefined
};
export default PricingProvider;